import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import axios from 'axios';
import "../../../Styles/LpaStoreAnalysisStyles.css";
import { lpaFrontlineDetailsState } from '../../../Recoil/LpaFrontlineDetailsState';
import { auditCodeAtom } from '../../../Recoil/auditCodeAtom';

const LpaFrontLineFeedback = () => {
  const setLpaFrontlineDetails = useSetRecoilState(lpaFrontlineDetailsState);
  const lpaFrontlineDetails = useRecoilValue(lpaFrontlineDetailsState);
  const auditCodevalue = useRecoilValue(auditCodeAtom);

  const [isLoading, setIsLoading] = useState(true);
  const [isDataReady, setIsDataReady] = useState(false);
  

  useEffect(() => {
    // Fetch data from the API and update LPAQuestions in the atom
    const fetchData = async () => {
      try {
        const response = await axios.get('https://myworxit.co.za/api/audits/frontlineSectionTableDetails.php');
        const newData = response.data.records;
        // Update the LPAQuestions in the atom if newData is an array
        if (Array.isArray(newData)) {
          setLpaFrontlineDetails(newData);
       
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setIsLoading(false);
      }
    };

    fetchData()
      .then(() => setIsDataReady(true)) // Set isDataReady to true when the data is available
      .catch(() => setIsDataReady(true)); // Also set isDataReady to true if there's an error to prevent an infinite loading state
  }, [setLpaFrontlineDetails]);

  if (!Array.isArray(lpaFrontlineDetails)) {
    return <div>Loading...</div>; // or return an empty component if desired
  }

  const filteredFrontlineDetails = lpaFrontlineDetails.filter(details => details.auditCode === auditCodevalue.auditCode);
  console.log('rendered:', filteredFrontlineDetails)

  if (!isDataReady) {
    return <div>Loading...</div>;
  }

  if (isLoading) {
    return <div>Loading...</div>;
  }

  
    return (
        <div className='questionContainer'>
            <div className='titleHeader'>
                <h4>LPA Store Analysis : Frontlne</h4>
            </div>
            <table>
                <thead>
                    <tr>
                        {/* <th className="typeWidth">Type</th> */}
                        <th className="scoreTypeColumnWidth">Type</th>
                        <th className="answersColumnWidth">LPA Questions</th>
                        <th className="questionsColumnWidth">Observation/Responses</th>
                        <th className="notesColumnWidth">Notes </th>
                    </tr>
                </thead>
                <tbody>
                    {filteredFrontlineDetails.map((question, index) => (
                        <tr key={index}>
                        <td className="scoreTypeColumnWidth">
                            {question.scores === 'Pass' ? (
                                <div className='passCircle'></div>
                            ) : question.scores === 'Fail' ? (
                                <div className='failCircle'></div>
                            ) : (
                                <div className='naCircle'></div>
                            )}
                        </td>
                        <td className="questionsColumnWidth">{question.question}</td>
                        <td className="answersColumnWidth">{question.responses} </td>
                        <td className="notesColumnWidth">{question.notes} </td>
                        </tr>
                    ))}
                    </tbody>
            </table>  
            <div className='titleFooter'>
                {filteredFrontlineDetails.length > 0 && (
                    <h4>Frontline LPA Score = {filteredFrontlineDetails[0].totalScore}%</h4>
                )}
            </div>
        </div>
   
    )
}

export default LpaFrontLineFeedback;